export function compare(value1: string, value2: string) {
  if (value1 < value2) return -1;
  if (value1 > value2) return 1;
  return 0;
}
